import React from 'react';
import styles from './Footer.module.scss';

// files
import fl1 from './../../Assets/files/fl1.pdf';

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.mainBlock}>
          <div className={styles.contacts}>
            <div className={styles.title} id='scrollFooter'>Контакты</div>
            <div className={styles.text}>Адрес: 196006 , Россия, Санкт-Петербург, <br /> Малая Митрофаньевская улица, д.4, литера Л, офис № 315</div>
            <div className={styles.text}>Телефон:{" "} <a href="tel:+78129485599">+7 (812) 948-55-99</a></div>
            <div className={styles.text}>Email:{" "} <a href="mailto:info@eci.su">info@eci.su</a></div>
          </div>
          <div className={styles.contacts}>
            <div className={styles.title}>СОУТ</div>
            <a href={fl1} className={styles.text}>Сводная ведомость результатов проведения СОУТ</a>
          </div>
        </div>
        <div className={styles.bottomBlock}>
          AO «ЭСП» 2026 Все права защищены
        </div>
      </div>
    </div>
  )
}

export default React.memo(Footer);